import {Col, Row} from 'antd';
import {AiFillDelete, AiOutlineMail} from 'react-icons/ai';
import {useIntl} from 'react-intl';
import ButtonComponent from 'src/shared/components/button';
import {FaCheck} from 'react-icons/fa';
import {FiSend} from 'react-icons/fi';
import {useCreateCampaign} from '../../hooks/useCreateCampaign';
import {useNavigate, useParams} from 'react-router-dom';
import {useSendMassEmail} from '../../hooks/useSendMassEmail';
import MainUtils from 'src/shared/utils/main';
import {useDeleteCampaign} from '../../hooks/useDeleteCampaign';
import {useUpdateCampaign} from '../../hooks/useUpdateCampaign';
import {BsFillArrowLeftCircleFill} from 'react-icons/bs';
import IntlMessages from 'src/domain/utility/IntlMessages';

function ActionsHeader({formik}: any) {
  const {messages} = useIntl();
  const navigate = useNavigate();
  const {id} = useParams();
  const {mutate: addCampaign, isLoading: addLoading} = useCreateCampaign();
  const {mutate: updateCampaign, isLoading: updateLoading} =
    useUpdateCampaign();
  const {mutate: sendMass, isLoading: sendLoading} = useSendMassEmail();
  const {mutate: deleteCampaign, isLoading: deleteLoading} =
    useDeleteCampaign();

  const handleSubmit = () => {
    if (id) {
      updateCampaign(
        {...formik.values, Body: formik.values.BodyEditor, Id: id},
        {
          onSuccess: () =>
            navigate('/promotions/promotions.news-letter/mailing-campaigns'),
        },
      );
    } else {
      addCampaign(
        {...formik.values, Body: formik.values.BodyEditor},
        {
          onSuccess: () =>
            navigate('/promotions/promotions.news-letter/mailing-campaigns'),
        },
      );
    }
  };

  const handleSubmitAndContinue = () => {
    if (id) {
      updateCampaign(
        {...formik.values, Id: id},
        {
          onSuccess: (data) =>
            navigate(
              `/promotions/promotions.news-letter/mailing-campaigns/edit/${data?.Id}`,
            ),
        },
      );
    } else {
      addCampaign(formik.values, {
        onSuccess: (data) =>
          navigate(
            `/promotions/promotions.news-letter/mailing-campaigns/edit/${data?.Id}`,
          ),
      });
    }
  };

  const handleSendMassEmail = () => {
    sendMass({...formik.values, Id: id});
  };

  const handleDelete = () => {
    deleteCampaign(id ?? '', {
      onSuccess: (data) =>
        navigate('/promotions/promotions.news-letter/mailing-campaigns'),
    });
  };

  return (
    <Col span={24}>
      <Row className='fullContent' justify={'space-between'}>
        <Col>
          <div className='text-title'>
            <span className='icon-title'>
              <AiOutlineMail />
            </span>
            {messages['mailing.add.new'].toString()}
            <small className='back-to-list'>
              <BsFillArrowLeftCircleFill className='back-to-icon' />
              <a
                onClick={() => {
                  navigate(
                    '/promotions/promotions.news-letter/mailing-campaigns',
                  );
                }}>
                <IntlMessages id='mailing.backTo' />
              </a>
            </small>
          </div>
        </Col>
        <Row gutter={[5, 5]}>
          <Col>
            <ButtonComponent
              loading={addLoading || updateLoading}
              onClickAction={handleSubmit}
              disabled={
                !formik.dirty || !formik.isValid || addLoading || sendLoading
              }
              icon={<FaCheck className='add-button-icon' />}
              type='primary'
              text={messages['common.save'].toString()}
              size='small'
              className='add-button'
            />
          </Col>
          <Col>
            <ButtonComponent
              loading={addLoading}
              onClickAction={handleSubmitAndContinue}
              disabled={
                !formik.dirty || !formik.isValid || addLoading || sendLoading
              }
              icon={<FaCheck className='add-button-icon' />}
              type='primary'
              text={messages['common.saveAndContinueEdit'].toString()}
              size='small'
              className='add-button'
            />
          </Col>
          <Col>
            <ButtonComponent
              onClickAction={handleSendMassEmail}
              disabled={
                !formik.isValid ||
                addLoading ||
                sendLoading ||
                MainUtils.isEmptyValue(id)
              }
              icon={<FiSend className='add-button-icon' />}
              type='primary'
              text={messages['mailing.sendMassEmail'].toString()}
              size='small'
              className='add-button'
            />
          </Col>
          {!MainUtils.isEmptyValue(id) && (
            <Col>
              <ButtonComponent
                loading={deleteLoading}
                onClickAction={handleDelete}
                icon={<AiFillDelete className='add-button-icon' />}
                type='primary'
                danger
                text={messages['common.delete'].toString()}
                size='small'
                className='add-button'
              />
            </Col>
          )}
        </Row>
      </Row>
    </Col>
  );
}

export default ActionsHeader;
